import React, { useCallback, useContext } from 'react'
import { css } from '@emotion/core'
import { colors, Icon, Table, Typography } from '@dw/helix'

import { ArticlesContext } from '../../contexts'
import { PurchaseOrder } from './GenerateSerialNumbersPage'
import makeShortSizeCode from '../../utils/makeShortSizeCode'

const purchaseOrderPanelStyles = css`
  background-color: #fff;
  padding: 0 21px 42px;
  border-radius: 2px;
  box-shadow: 0 1px 7px 0 rgba(0, 0, 0, 0.19), 0 3px 3px 0 rgba(0, 0, 0, 0.13);
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
`

const panelHeadingStyles = css`
  margin-top: 20px;
  margin-bottom: 19.8px;
`

const closeButtonStyles = css`
  position: absolute;
  box-sizing: content-box;
  width: 15px;
  height: 15px;
  padding: 10px;
  top: 13px;
  right: 10px;
  background-color: transparent;
  border: 0;
  display: flex;
  svg {
    fill: ${colors.brandBlue};
  }
`

const tableStyles = css`
  width: 100%;
`

const descriptionStyles = css`
  width: 90%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

interface PONumberInformationProps {
  purchaseOrder: PurchaseOrder
  onClose: () => any
}

const PONumberInformation: React.FunctionComponent<PONumberInformationProps> = props => {
  const { articles } = useContext(ArticlesContext)

  const renderDescription = useCallback(
    ({ articleId }) => {
      if (!articles[articleId]) {
        return
      }
      const { collectionCode, sizeCode, modelCode, baseColorCode, secondColorCode } = articles[articleId]

      const description = [collectionCode, makeShortSizeCode(sizeCode), modelCode, baseColorCode, secondColorCode]
        .filter(val => !!val)
        .join(' ')

      return (
        <span title={description} css={descriptionStyles}>
          {description}
        </span>
      )
    },
    [articles],
  )

  return (
    <div css={purchaseOrderPanelStyles}>
      <Typography type="h4" css={panelHeadingStyles}>
        Purchase order {props.purchaseOrder.orderId}
      </Typography>
      <button type="button" onClick={props.onClose} css={closeButtonStyles}>
        <Icon name="close" />
      </button>
      <Table
        items={props.purchaseOrder.items}
        columns={[
          { label: 'Art. No', field: 'articleId', width: '142px' },
          {
            label: 'Description',
            field: 'description',
            render: renderDescription,
            width: '260px',
          },
          {
            label: 'Scannable',
            field: 'scannable',
            render: ({ articleId }) => (articles[articleId] && articles[articleId].scannable ? 'Yes' : 'No'),
            width: '91px',
          },
          { label: 'Qty', field: 'quantity', width: '70px' },
        ]}
        rowKey={'articleId'}
        css={tableStyles}
      />
    </div>
  )
}

export { PONumberInformation }

export default React.memo(PONumberInformation)
